import { render, staticRenderFns } from "./Revenue-page.vue?vue&type=template&id=45744db3&scoped=true&"
import script from "./Revenue-page.vue?vue&type=script&lang=js&"
export * from "./Revenue-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45744db3",
  null
  
)

export default component.exports